import { api } from "@/lib/api";
import type { PublicWarningsLegacyComment } from "@/lib/api/types";

export const riskPictureLegacyCommentKey = () => ["riskPictureLegacyComment"] as const;

export async function fetchRiskPictureLegacyComment(): Promise<PublicWarningsLegacyComment> {
  const { data } = await api.data.getPublicWarningsLegacyComment();
  return data;
}
